function sendAnalyticsEvent (category, action, label) {
  if (window.gtag) {
    gtag('event', action, {
      'event_category': category,
      'event_label': label,
      'non_interaction': true,
    })
  } else if (window.ga) {
    ga('send', {
      hitType: 'event',
      eventCategory: category,
      eventAction: action,
      eventLabel: label,
      nonInteraction: true,
    })
  }
}

if (!Element.prototype.matches) {
  Element.prototype.matches =
    Element.prototype.matchesSelector ||
    Element.prototype.mozMatchesSelector ||
    Element.prototype.msMatchesSelector ||
    Element.prototype.oMatchesSelector ||
    Element.prototype.webkitMatchesSelector ||
    function(s) {
      var matches = (this.document || this.ownerDocument).querySelectorAll(s),
        i = matches.length;
      while (--i >= 0 && matches.item(i) !== this) {}
      return i > -1;
    };
}

document.addEventListener( 'click', e => {
  if (e.target && e.target.matches('a[href^="tel:"]')) {
    const phone = e.target.href.replace('tel:', '')
    sendAnalyticsEvent('Phone Call Tracking', 'Click to Call', phone)
  }
} )
